/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FaqShowResponse } from '../../models/faq-show-response';

export interface GetFaqShow$Params {
  name: string;
}

export function getFaqShow(http: HttpClient, rootUrl: string, params: GetFaqShow$Params, context?: HttpContext): Observable<StrictHttpResponse<FaqShowResponse>> {
  const rb = new RequestBuilder(rootUrl, getFaqShow.PATH, 'get');
  if (params) {
    rb.path('name', params.name, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FaqShowResponse>;
    })
  );
}

getFaqShow.PATH = '/v1/faq/{name}';
